import { Popover as AntPopover } from 'antd';

/**
 * Wrapper component for Ant Design Popover
 *
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Popover functionality including title, content, placement, and trigger options.
 *
 * @component
 * @example
 * import { Popover, Button } from '../GeneralComponents/ui';
 *
 * <Popover content="Content" title="Title">
 *   <Button type="primary">Hover me</Button>
 * </Popover>
 *
 * <Popover
 *   content={<div>Content</div>}
 *   title="Title"
 *   trigger="click"
 * >
 *   <Button>Click me</Button>
 * </Popover>
 *
 * @see https://ant.design/components/popover/ - Ant Design Popover documentation
 */
const Popover = (props) => {
    return (
        <AntPopover
            {...props}
            overlayInnerStyle={{
                borderRadius: 16,
                overflow: 'hidden',
                ...props.overlayInnerStyle,
            }}
        />
    );
};

export default Popover;
